/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import { skeletonConstants } from '../constants/skeletonConstants';

export const ChartLoader = memo<IContentLoaderProps>(props => (
  <ContentLoader
    height={225}
    width={420}
    speed={2}
    backgroundColor={skeletonConstants.backgroundColor}
    foregroundColor={skeletonConstants.foregroundColor}
    {...props}
  >
    <circle cx="90" cy="105" r="90" />
    <rect x="212" y="39" rx="6" ry="6" width="135" height="28" />
    <rect x="355" y="51" rx="4" ry="4" width="46" height="15" />
    <rect x="212" y="100" rx="6" ry="6" width="135" height="28" />
    <rect x="355" y="111" rx="4" ry="4" width="46" height="15" />
  </ContentLoader>
));
